<template>
  <v-container
    fill-height
    fluid
  >
    <v-tabs v-model="typeCommissions">
      <v-tab :disabled="loading" :href="'#all'">All</v-tab>
      <v-tab :disabled="loading" :href="'#external'">External</v-tab>
      <v-tab :disabled="loading" :href="'#internal'">Internal</v-tab>
    </v-tabs>

    <v-data-table
      :headers="headers"
      :items="filteredItems"
      :loading="loading"
      :items-per-page="-1"
      hide-default-footer
      class="col-12 pa-0 commission-dt"
      fixed-header
      height="calc(100vh - 72px)"
    >
      <template v-slot:header.action="{ item }">
        <v-btn
          text
          title="Save All"
          class="px-0"
          style="min-width: 36px"
          @click="save"
        >
          <v-icon>mdi-content-save-all</v-icon>
        </v-btn>
        <v-btn
          text
          title="Add"
          class="px-0"
          @click="addNew"
          style="min-width: 36px"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn
          text
          title="Add"
          class="px-0"
          @click="search"
          style="min-width: 36px"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </template>
      <template v-slot:item="{item}">
        <commission-table-row
          :item="item"
          :items="items"
          :paymethods="paymethods"
          :gameBrand="gameBrand"
          :system_brand="system_brand"
          :projects-by-id="projectsById"
        />
      </template>
    </v-data-table>

  </v-container>
</template>

<style>
  .commission-dt thead th {
    white-space: nowrap;
  }

  .commission-dt .v-select__selections {
    display: contents;
  }

  .comma-sep:not(:first-child):before {
    content: ", ";
  }
</style>

<script>
  import { API } from '@/utils/api'
  import { concat, uniq, map, sortBy, keyBy } from 'lodash'
  import CommissionTableRow from '@/components/commissions/table-row.vue'

  export default {
    components: { CommissionTableRow },
    data: () => ({
      chipCount: 3,
      addedNew: false,
      loading: false,
      typeCommissions: 'all',
      headers: [
        { text: '', value: 'action', sortable: false },
        { text: 'Project', value: 'entity_id' },
        { text: 'Target', value: 'paymethod_name' },
        { text: 'Country', value: 'country' },
        { text: 'Currency', value: 'currency' },
        { text: 'Type Commissions', value: 'type' },
        { text: 'GGR Fee', value: 'settings.ggr.fee_rate' },
        { text: 'D Hold %', value: 'settings.hold' },
        { text: 'D Fee', value: 'settings.deposit.fee_rate' },
        { text: 'D Currency', value: 'settings.deposit.currency' },
        { text: 'D Per Transaction', value: 'settings.deposit.per_transaction' },
        { text: 'W Fee', value: 'settings.withdraw.fee_rate' },
        { text: 'W Currency', value: 'settings.withdraw.currency' },
        { text: 'W Per Transaction', value: 'settings.withdraw.per_transaction' },
        { text: 'CB Fee', value: 'settings.chargeback.fee_rate' },
        { text: 'CB Currency', value: 'settings.chargeback.currency' },
        { text: 'CB Per Transaction', value: 'settings.chargeback.per_transaction' },
        { text: 'Refund Fee', value: 'settings.refund.fee_rate' },
        { text: 'Refund Currency', value: 'settings.refund.currency' },
        { text: 'Refund Per Transaction', value: 'settings.refund.per_transaction' },
        { text: 'Settlement Fee', value: 'settings.settlement_fee' },
      ],
      items: [],
      paymethods: [],
      gameBrand: [],
      system_brand: [],
    }),

    computed: {
      filteredItems () {
        if (this.typeCommissions === 'all') return this.items

        return this.items.filter(({ type, new: isNew }) => isNew || this.typeCommissions === type)
      },
      projectsById () {
        return keyBy(this.$store.state.auth.entities, 'entity_id');
      }
    },

    mounted () {
      this.search()
      this.loadPaymethods()
      this.loadBrand()
    },

    methods: {
      concat, uniq,

      save () {
        this.loading = true
        return API.call('/$v/commission/update.json', {
          data: this.items.filter(o => o.edit || o.new)
        }, null, this.$store.state.auth.entities[0]).then(() => this.search()).finally(() => this.loading = false)
      },

      addNew () {
        this.items = concat([
          {
            new: true,
            paymethod_name: [],
            entity_id: [ '*' ],
            type: 'external',
            currency: [ 'Any' ],
            country: [ 'Any' ],
            settlement_fee: 0,
            settings: {
              ggr: {},
              deposit: {},
              withdraw: {},
              chargeback: {},
              refund: {}
            }
          }
        ], this.items)
      },

      loadPaymethods () {
        return API.call('/$v/paymethod/name_list.json', { with_sub: true }, null, this.$store.state.auth.entities[0]).then(resp => {
          this.paymethods = sortBy(map(resp.data, 'name'), (o) => o)
        })
      },
      loadBrand () {
        return API.call('/$v/game/list.json', {
          all: true,
          wo_games: true,
        }).then(resp => {
          this.system_brand = map(resp.system_brand, (i) => ({ text: i.name, value: i.alias }))
        }).catch(e => {
        }).finally(() => {
          this.loading = false
        })
      },
      search () {
        this.loading = true
        return API.call('/$v/commission/list.json', {}, null, this.$store.state.auth.entities[0]).then(resp => {
          this.items = resp.data
          return resp.data
        }).finally(() => {
          this.loading = false
        })
      },
    },
  }
</script>
